import { IConfirmDialogConfig } from "./confirm-dialog.config.interface";
import { ConfirmationDialogService } from "./confirm-dialog.service";

export function needConfirmation(confirmData: IConfirmDialogConfig) {
	return function (target: Object, propertyKey: string, descriptor: PropertyDescriptor) {
		const originalMethod = descriptor.value;
		
		descriptor.value = async function(...args: unknown[]) {
			const confirmationService = ConfirmationDialogService.getInstance() as ConfirmationDialogService;

			confirmationService.open(confirmData).subscribe({
				next: (val) => {
					if (val === "confirmed") {
						originalMethod.apply(this, args);
					}
				}	
			});
		};

		return descriptor;
	};
}